// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.buttonWrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.buttonWrapper.loading button {
  pointer-events: none;
  opacity: 0.8;
}

.spinnerIcon {
  font-size: 1.5rem;
  color: #3498db;
  margin-right: 0.5rem;
  animation: spin 1s linear infinite;
}



/* Add spinner styles */
.spinnerIcon {
    animation: spin 1s infinite linear;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* Disable button style */
  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  `, "",{"version":3,"sources":["webpack://./src/Component/HOC/loadingButton.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,kCAAkC;AACpC;;;;AAIA,uBAAuB;AACvB;IACI,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA,yBAAyB;EACzB;IACE,YAAY;IACZ,mBAAmB;EACrB","sourcesContent":["\n.buttonWrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.buttonWrapper.loading button {\n  pointer-events: none;\n  opacity: 0.8;\n}\n\n.spinnerIcon {\n  font-size: 1.5rem;\n  color: #3498db;\n  margin-right: 0.5rem;\n  animation: spin 1s linear infinite;\n}\n\n\n\n/* Add spinner styles */\n.spinnerIcon {\n    animation: spin 1s infinite linear;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  /* Disable button style */\n  button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
